import BaseAPI from '../base'

function getAccount() {
    return BaseAPI.get('billing/account');
}

function getTransactions(limit, start, end) {
    return BaseAPI.get('billing/transactions', {
        limit: limit || 100,
        start,
        end
    });
}

function updateReminderSettings(threshold) {
    return BaseAPI.post('billing/reminder_settings', {
        threshold
    })
}

function getDepositForm(amount, cafe) {
    return BaseAPI.get('billing/deposit_form', {
        amount,
        cafe
    });
}

function getOutcomeStats() {
    return BaseAPI.get('billing/outcome_stats');
}

export default {
    getAccount,
    getTransactions,
    updateReminderSettings,
    getDepositForm,
    getOutcomeStats
}